<template>
    <v-container fluid>
        <!-- KPI: calcolati client-side sulla lista filtrata, stesso approccio di Pagamenti. -->
        <v-row class="mb-2">
            <v-col cols="6" md="3">
                <v-card variant="outlined" class="rounded-lg" height="100%">
                    <v-card-text>
                        <div class="d-flex align-center justify-space-between">
                            <div>
                                <div class="text-caption text-medium-emphasis">Da incassare</div>
                                <div class="text-h5 font-weight-bold">{{ formattaImporto(kpi.totaleDaIncassare) }}</div>
                                <div class="text-caption text-medium-emphasis">{{ kpi.numeroDaIncassare }} incassi</div>
                            </div>
                            <v-avatar color="blue-lighten-4" size="44">
                                <v-icon color="primary">mdi-cash-clock</v-icon>
                            </v-avatar>
                        </div>
                    </v-card-text>
                </v-card>
            </v-col>

            <v-col cols="6" md="3">
                <v-card variant="outlined" class="rounded-lg" height="100%">
                    <v-card-text>
                        <div class="d-flex align-center justify-space-between">
                            <div>
                                <div class="text-caption text-medium-emphasis">Scaduti</div>
                                <div class="text-h5 font-weight-bold">{{ formattaImporto(kpi.totaleScaduto) }}</div>
                                <div class="text-caption text-medium-emphasis">{{ kpi.numeroScaduto }} incassi</div>
                            </div>
                            <v-avatar color="red-lighten-4" size="44">
                                <v-icon color="error">mdi-alert-circle</v-icon>
                            </v-avatar>
                        </div>
                    </v-card-text>
                </v-card>
            </v-col>

            <v-col cols="6" md="3">
                <v-card variant="outlined" class="rounded-lg" height="100%">
                    <v-card-text>
                        <div class="d-flex align-center justify-space-between">
                            <div>
                                <div class="text-caption text-medium-emphasis">Incassati</div>
                                <div class="text-h5 font-weight-bold">{{ formattaImporto(kpi.totaleIncassato) }}</div>
                                <div class="text-caption text-medium-emphasis">{{ kpi.numeroIncassato }} incassi</div>
                            </div>
                            <v-avatar color="green-lighten-4" size="44">
                                <v-icon color="success">mdi-check-circle</v-icon>
                            </v-avatar>
                        </div>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>

        <!-- Filtri -->
        <v-row class="align-center mb-2">
            <v-col cols="12" sm="6" md="3">
                <v-select v-model="tipoIncassoId" :items="tipiIncasso" item-title="nome" item-value="id"
                    label="Tutte le tipologie" density="compact" variant="outlined" hide-details clearable
                    @update:modelValue="carica" />
            </v-col>
            <v-col cols="12" sm="6" md="3">
                <v-select v-model="clienteId" :items="clienti" item-title="nome" item-value="id"
                    label="Tutti i clienti" density="compact" variant="outlined" hide-details clearable
                    @update:modelValue="carica" />
            </v-col>
            <v-col cols="12" sm="6" md="3">
                <v-select v-model="stato" :items="statiDisponibili" item-title="label" item-value="value"
                    label="Tutti gli stati" density="compact" variant="outlined" hide-details clearable
                    @update:modelValue="carica" />
            </v-col>
            <v-col cols="12" sm="6" md="3">
                <v-text-field v-model="idDocumentoInterno" label="ID documento interno" density="compact"
                    variant="outlined" hide-details clearable />
            </v-col>
            <v-col cols="12" sm="6" md="3">
                <v-text-field v-model="numDocumentoInterno" label="Numero documento interno" density="compact"
                    variant="outlined" hide-details clearable />
            </v-col>
            <v-col cols="12" class="d-flex flex-wrap justify-end" style="gap:8px">
                <v-btn variant="outlined" prepend-icon="mdi-cog-outline" to="/tipi-incasso">Tipi incasso</v-btn>
                <v-btn variant="outlined" prepend-icon="mdi-domain" to="/clienti">Clienti</v-btn>
                <v-btn color="primary" prepend-icon="mdi-plus" @click="apriDialog(null)">Nuovo incasso</v-btn>
            </v-col>
        </v-row>

        <v-data-table :headers="headers" :items="incassi" :items-per-page="15" density="comfortable">
            <template #[`item.stato`]="{ item }">
                <v-chip size="small" :color="coloreRiga(item)" variant="flat">
                    {{ etichettaRiga(item) }}
                </v-chip>
            </template>

            <template #[`item.importo`]="{ item }">
                {{ formattaImporto(item.importo) }}
            </template>

            <template #[`item.dataScadenza`]="{ item }">
                {{ formatData(item.dataScadenza) }}
            </template>

            <template #[`item.dataIncasso`]="{ item }">
                {{ formatData(item.dataIncasso) }}
            </template>

            <template #[`item.pagatore`]="{ item }">
                {{ item.clienteNome || item.pagatoreNote || '—' }}
            </template>

            <template #[`item.azioni`]="{ item }">
                <v-btn v-if="item.stato === 'DaIncassare'" size="small" variant="text" color="success"
                    @click="apriCompletamento(item)">
                    Segna incassato
                </v-btn>
                <v-btn icon variant="text" size="small" title="Duplica" @click="duplica(item)">
                    <v-icon>mdi-content-copy</v-icon>
                </v-btn>
                <v-btn icon variant="text" size="small" @click="apriDialog(item)">
                    <v-icon>mdi-pencil</v-icon>
                </v-btn>
                <v-btn icon variant="text" size="small" color="error" @click="chiediEliminazione(item)">
                    <v-icon>mdi-delete</v-icon>
                </v-btn>
            </template>
        </v-data-table>

        <!-- Un solo dialog CRUD: niente vista di dettaglio separata, come per Pagamenti. -->
        <dialog-incasso v-model="dialog" :incasso="incassoSelezionato" :valori-iniziali="valoriIniziali"
            :documenti-readonly="documentiReadonly" @salvato="onSalvato" />

        <dialog-completa-incasso v-model="dialogCompletamento" :incasso="incassoSelezionato"
            @completato="onCompletato" />

        <v-dialog v-model="dialogElimina" max-width="420">
            <v-card>
                <v-card-title>Confermi l'eliminazione?</v-card-title>
                <v-card-text>L'incasso verrà rimosso.</v-card-text>
                <v-card-actions>
                    <v-spacer />
                    <v-btn variant="text" @click="dialogElimina = false">Annulla</v-btn>
                    <v-btn color="error" @click="confermaEliminazione">Elimina</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
import DialogIncasso from "@/components/incassi/DialogIncasso.vue";
import DialogCompletaIncasso from "@/components/incassi/DialogCompletaIncasso.vue";
import { STATI_INCASSO, coloreRiga, etichettaRiga, isScaduto } from "@/constants/statoIncasso.js";
import { leggiFiltriDaQuery, scriviFiltriSuQuery } from "@/utils/filtriUrl.js";
import storage from "@/services/storage.js";

export default {
    name: "IncassiPage",

    components: {
        DialogIncasso,
        DialogCompletaIncasso,
    },

    data() {
        return {
            tipoIncassoId: null,
            clienteId: null,
            stato: null,
            idDocumentoInterno: "",
            numDocumentoInterno: "",
            debounceDocumento: null,
            statiDisponibili: STATI_INCASSO,
            dialog: false,
            incassoSelezionato: null,
            valoriIniziali: null,
            dialogCompletamento: false,
            dialogElimina: false,
            incassoDaEliminare: null,
            headers: [
                { title: "Tipologia", key: "tipoIncassoNome" },
                { title: "Pagatore", key: "pagatore" },
                { title: "Importo", key: "importo" },
                { title: "Scadenza", key: "dataScadenza" },
                { title: "Incassato il", key: "dataIncasso" },
                { title: "Stato", key: "stato" },
                { title: "ID doc. interno", key: "idDocumentoInterno" },
                { title: "N. doc. interno", key: "numDocumentoInterno" },
                { title: "", key: "azioni", sortable: false },
            ],
        };
    },

    computed: {
        // Vedi commento analogo in Pagamenti.vue.
        documentiReadonly() {
            if (this.$route.query.readonly !== "1") return false;
            return !!(this.valoriDocumentoDaUrl());
        },
        incassi() {
            return this.$store.getters["incassi/lista"];
        },
        tipiIncasso() {
            return this.$store.getters["tipiIncasso/lista"];
        },
        clienti() {
            return this.$store.getters["clienti/lista"];
        },
        kpi() {
            const lista = this.incassi;
            const daIncassare = lista.filter(i => i.stato === "DaIncassare" && !isScaduto(i));
            const scaduti = lista.filter(i => isScaduto(i));
            const incassati = lista.filter(i => i.stato === "Incassato");
            const somma = arr => arr.reduce((tot, i) => tot + (i.importo || 0), 0);
            return {
                totaleDaIncassare: somma(daIncassare),
                numeroDaIncassare: daIncassare.length,
                totaleScaduto: somma(scaduti),
                numeroScaduto: scaduti.length,
                totaleIncassato: somma(incassati),
                numeroIncassato: incassati.length,
            };
        },
    },

    watch: {
        idDocumentoInterno() {
            clearTimeout(this.debounceDocumento);
            this.debounceDocumento = setTimeout(() => this.carica(), 300);
        },
        numDocumentoInterno() {
            clearTimeout(this.debounceDocumento);
            this.debounceDocumento = setTimeout(() => this.carica(), 300);
        },
    },

    async mounted() {
        Object.assign(this, leggiFiltriDaQuery(this.$route, {
            tipoIncassoId: "number",
            clienteId: "number",
            stato: "string",
            idDocumentoInterno: "string",
            numDocumentoInterno: "string",
        }));
        // Vedi commento analogo in Pagamenti.vue: atteso prima di carica() per evitare
        // che quest'ultimo ricostruisca la query da this.$route.query non ancora aggiornato.
        await this.apriDaUrlSeRichiesto();
        this.ripristinaBozzaSePresente();
        this.$store.dispatch("tipiIncasso/carica");
        this.$store.dispatch("clienti/carica");
        this.carica();
    },

    methods: {
        coloreRiga,
        etichettaRiga,

        // Vedi commento analogo in Pagamenti.vue.
        async apriDaUrlSeRichiesto() {
            if (this.$route.query.nuovo !== "1") return;

            const CAMPI_PRECOMPILABILI = {
                tipoIncassoId: "number",
                clienteId: "number",
                pagatoreNote: "string",
                importo: "number",
                dataScadenza: "string",
                descrizione: "string",
                ricorrente: "boolean",
                idDocumentoInterno: "string",
                numDocumentoInterno: "string",
            };

            this.valoriIniziali = leggiFiltriDaQuery(this.$route, CAMPI_PRECOMPILABILI);
            this.incassoSelezionato = null;
            this.dialog = true;

            const query = { ...this.$route.query };
            delete query.nuovo;
            Object.keys(CAMPI_PRECOMPILABILI).forEach(chiave => delete query[chiave]);
            await this.$router.replace({ query }).catch(() => {});
        },

        // Vedi commento analogo in Pagamenti.vue.
        ripristinaBozzaSePresente() {
            if (this.dialog) return;
            const bozza = storage.getBozza("incasso");
            if (!bozza) return;

            this.incassoSelezionato = null;
            this.valoriIniziali = bozza;
            this.dialog = true;
        },

        async carica() {
            const filtri = this.filtriCorrenti();
            scriviFiltriSuQuery(this.$router, this.$route, filtri);
            try {
                await this.$store.dispatch("incassi/carica", filtri);
            } catch (error) {
                console.log(error);
            }
        },

        filtriCorrenti() {
            return {
                tipoIncassoId: this.tipoIncassoId || undefined,
                clienteId: this.clienteId || undefined,
                stato: this.stato || undefined,
                idDocumentoInterno: this.idDocumentoInterno || undefined,
                numDocumentoInterno: this.numDocumentoInterno || undefined,
            };
        },

        apriDialog(item) {
            this.incassoSelezionato = item;
            this.valoriIniziali = item ? null : this.valoriDocumentoDaUrl();
            this.dialog = true;
        },

        // Vedi commento analogo in Pagamenti.vue.
        valoriDocumentoDaUrl() {
            const valori = leggiFiltriDaQuery(this.$route, {
                idDocumentoInterno: "string",
                numDocumentoInterno: "string",
            });
            return (valori.idDocumentoInterno || valori.numDocumentoInterno) ? valori : null;
        },

        onSalvato() {
            this.carica();
        },

        apriCompletamento(item) {
            this.incassoSelezionato = item;
            this.dialogCompletamento = true;
        },

        onCompletato() {
            this.carica();
        },

        async duplica(item) {
            try {
                await this.$store.dispatch("incassi/duplica", { id: item.id, filtri: this.filtriCorrenti() });
            } catch (error) {
                console.log(error);
            }
        },

        chiediEliminazione(item) {
            this.incassoDaEliminare = item;
            this.dialogElimina = true;
        },

        async confermaEliminazione() {
            try {
                await this.$store.dispatch("incassi/elimina", {
                    id: this.incassoDaEliminare.id,
                    filtri: this.filtriCorrenti(),
                });
            } catch (error) {
                console.log(error);
            }
            this.dialogElimina = false;
        },

        formattaImporto(importo) {
            return (importo || 0).toLocaleString("it-IT", { style: "currency", currency: "EUR" });
        },

        formatData(data) {
            return data ? new Date(data).toLocaleDateString("it-IT") : "—";
        },
    },
};
</script>
